// import Video from 'react-native-video';
import { adUnits, IAdaptiveActionCard } from '@ninjacart/nc-nk-core';
import {
  addEventParam,
  INinjaEvent,
  useEventStore,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import {
  handleMarketingEvents,
  KissanEventType,
  msToTime,
  sendToFirebasEvents,
  updateVideoStreamPlayback,
  useAppPersistenceStore,
  useEventZStore,
  useFeedStore,
} from '@ninjacart/nc-nk-store';
import {
  SizableText,
  Spinner,
  useMedia,
  useTheme,
  VideoPlayIconRegular,
  View,
  XStack,
  YStack,
} from '@ninjacart/nc-nk-ui';
import { NKPlayerRef, VideoWebRef } from '@ninjacart/nc-nk-video';
import {
  BannerAds,
  BannerAdSize,
  useIsFocused,
  useRouter,
} from '@ninjacart/nc-nk-web-deps';
import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator, GestureResponderEvent, ImageBackground, Platform } from 'react-native';
import Orientation from 'react-native-orientation-locker';
import Animated, { SharedValue, useSharedValue } from 'react-native-reanimated';
import { usePathname } from 'next/navigation';
import { requestNotificationPermission } from "@ninjacart/nc-nk-firebase";

interface IFeedVideoProps {
  item: IAdaptiveActionCard;
  index: number;
  currentInfoRef: any;
  duration?: number;
  onAutoPlayModeExpandCallback: (isExpanded: boolean) => void;
  height: SharedValue<number>;
  isVideoFeedActive: boolean;
  adTagurl: string | undefined;
  pageName?: string;
  deviceWidth?: number;
  isExpanded: boolean;
  isAutoPlayBannerAdEnabled: boolean;
  setLongVideoSelected?: (selectedLongVideo?: IAdaptiveActionCard) => void;
  videoHeight?: number;
  onVideoMuted?: (isMuted?: boolean) => void;
}

const Video = lazy(() =>
  import('@ninjacart/nc-nk-video').then((module) => ({ default: module.Video }))
);

// if (Platform.OS === 'web') {
//   LazyVideoComponent =
// }

const AD_SHOW_DURATION = 6;

const FeedVideoCard = ({
  item,
  index,
  currentInfoRef,
  duration,
  onAutoPlayModeExpandCallback,
  height,
  isVideoFeedActive,
  adTagurl,
  pageName,
  deviceWidth,
  isExpanded,
  isAutoPlayBannerAdEnabled,
  setLongVideoSelected,
  videoHeight = 250,
  onVideoMuted,
}: IFeedVideoProps) => {
  const lastItemId = useRef(item?.actionData?.content?.id);
  const videoRef = useRef<VideoWebRef>(null);
  const playerRefWeb = useRef<NKPlayerRef>(null);
  const thumbnail = useRef(item?.actionData?.mediaDetails?.[0]?.preview_url);
  // const thumbnail = useRef(item?.actionData?.mediaDetails?.[0]?.preview_url)
  const [remainingTime, setRemainingTime] = useState(duration ?? 0);

  // console.log('Item details => ', isVideoFeedActive, activeFeedItemIndex, index);
  const [isVideoReadyForPlay, setIsVideoReadyForPlay] = useState(false);
  const [showThumbnail, setShowThumbnail] = useState(false);
  const currentTime = useSharedValue(0);
  const min = useSharedValue(0);
  const thumbScaleValue = useSharedValue(1);
  const isScrubbing = useSharedValue(false);
  const max = useSharedValue(duration && duration > 30 ? 30 : (duration ?? 0));
  const setFeedVideoMuteEnable = useFeedStore((state) => state.setFeedVideoMuteEnable);
  const feedVideoMuteEnable = useFeedStore((state) => state.feedVideoMuteEnable);
  const enableAutoPlayModeFired = useRef(false);
  const startTimeRef = useRef(performance.now());
  const isFocused = useIsFocused();
  const [isLoading, setIsLoading] = useState(false);
  const [isAdActive, setIsAdActive] = useState(false);
  // const [showBannerAdOnFallback, setShowBannerAdOnFallback] = useState(false);
  const videoAdPlayStartRef = useRef(false);
  // const videoSource = useCallback(() => getVideoSource(), [index, activeFeedItemIndex]);
  const timeElapsedRef = useRef(0);
  const hasCalledHandleOnPlayProgressOne = useRef(false);
  const isVideoPlayedThirtySeconds = useRef(false);
  const isVideoPlayedTwentySeconds = useRef(false);
  const [adElapsedTimer, setAdElapsedTimer] = useState(5);
  // const setLongVideoSelected = useFeedStore((state) => state.setLongVideoSelected);
  const { push } = useRouter();
  const processEvents = useRef(useQueuedEventStore((state) => state.processEvents)).current;
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const adTimerShow = useEventZStore((state) => state.adTimershow);
  const bannerAdLoadTriggerFrequency = adTimerShow;
  const videoSource = {
    uri: item?.actionData?.content?.streamingPlaylistUrl,
    videoId: item?.actionData?.content?.id,
    // cropEnd: duration && duration > 30 ? 30 * 1000 : duration && duration * 1000,
  };
  const [bannerAdVisible, setBannerAdVisible] = useState(false);
  const [bannerAdLoad, setBannerAdLoad] = useState(false);
  const bannerAdLoadRequested = useRef(false);
  const timeoutRef = useRef<undefined | ReturnType<typeof setInterval>>();
  const bannerAdElapsedTimeRef = useRef(0);
  const isAdOpenedOrDismissed = useRef(false);
  const isVideoAdPlaying = useRef(false);
  const theme = useTheme();
  const [isAdCountStart, setAdCountStart] = useState(false);
  const { t } = useTranslation();
  // const setShowNotififactionPopup = useFeedStore((state) => state.setShowNotififactionPopup);
  const uniqueDeviceId = useAppPersistenceStore((state) => state.deviceId);
  const lastEventPublishedTimeRef = useRef(0);
  const hasAdEventTriggered = useRef(false);
  const mediaQ = useMedia();
  const pathname = usePathname() ?? '';

  useEffect(() => {
    const isHome = pathname === '/' || pathname === '/home';
    const video = videoRef.current;
    if (video) {
      if (isHome) {
        videoRef.current?.resume();
      } else {
        video?.pause?.();
      }
    }
  }, [pathname]);

  if (item?.actionData?.content?.id !== lastItemId.current) {
    // console.log('Calling reset on vars!!!');
    clearTimeout(timeoutRef.current);
    enableAutoPlayModeFired.current = false;
    lastItemId.current = item?.actionData?.content?.id;
    bannerAdElapsedTimeRef.current = 0;
    bannerAdLoadRequested.current = false;
    isAdOpenedOrDismissed.current = false;
    hasAdEventTriggered.current = false;
    // config.autoPlay = false;
    // setConfig(config);
    setShowThumbnail(true);
    setIsVideoReadyForPlay(false);
    setBannerAdLoad(false);
    thumbScaleValue.value = 1;
    min.value = 0;
    max.value = 0;
  }

  // useEffect(() => {
  //   if (!isVideoReadyForPlay) setIsLoading(false);
  // }, [isVideoReadyForPlay]);

  const getVideoSource = () => {
    return {
      uri: item?.actionData?.content?.streamingPlaylistUrl,
      cropEnd: duration && duration > 30 ? 30 * 1000 : duration && duration * 1000,
    };
  };

  const toggleMute = (e: GestureResponderEvent) => {
    e.stopPropagation();
    setFeedVideoMuteEnable(!feedVideoMuteEnable);
    // videoRef.current?.presentFullscreenPlayer();
    // Orientation.lockToLandscape();
  };

  const eventPublishV2 = async (seekTimeConst: number, duration: number, videoId?: string) => {
    try {
      if (seekTimeConst > duration) return;
      if (!videoId) return;
      await updateVideoStreamPlayback(videoId, seekTimeConst ?? 0, uniqueDeviceId);
    } catch (err) {
      console.error('Error publish video playback event. ', err);
    }
  };

  const initializeNotification = async () => {
    await requestNotificationPermission();
  };

  const onProgress = (data: { currentTime: number; seekableDuration: number }) => {
    if (!isScrubbing.value) currentTime.value = data.currentTime;
    // max.value = data?.seekableDuration;
    const currentSeekTime = Math.round(data.currentTime);
    if (
      currentSeekTime >= bannerAdLoadTriggerFrequency - 5 &&
      currentSeekTime <= bannerAdLoadTriggerFrequency + 5 &&
      !bannerAdLoadRequested.current
    ) {
      setAdCountStart(true); // Trigger the display
    }

    if (
      currentSeekTime >= bannerAdLoadTriggerFrequency &&
      !bannerAdLoadRequested.current &&
      !videoAdPlayStartRef.current
    ) {
      bannerAdLoadRequested.current = true;
      // setShowBannerAdOnFallback(true);
      setBannerAdLoad(true);
    }

    setRemainingTime(duration! - currentSeekTime);
    if (currentSeekTime) {
      currentInfoRef.current = {
        currentTime: Math.round(data.currentTime) || 0,
      };
    }

    if (currentSeekTime % 10 === 0 && lastEventPublishedTimeRef.current !== currentSeekTime) {
      eventPublishV2(currentSeekTime, data.seekableDuration, item?.actionData?.content?.id);
      lastEventPublishedTimeRef.current = currentSeekTime;
    }

    if (currentSeekTime > 3 && thumbScaleValue.value === 1 && !isScrubbing.value) {
      thumbScaleValue.value = 0;
    }

    // updateRemainingTime();
    //Event will fire after 10 sec
    if (currentSeekTime >= 10 && !hasCalledHandleOnPlayProgressOne.current) {
      handleOnPlayProgressOne();
      hasCalledHandleOnPlayProgressOne.current = true;
    }
    //Event will fire after 20 sec
    if (currentSeekTime >= 20 && !isVideoPlayedTwentySeconds.current) {
      handleOnPlayProgressTwentySeconds();
      isVideoPlayedTwentySeconds.current = true;
      if (Platform.OS === 'web') {
        initializeNotification();
      }
    }

    // after30 sec event will fire
    if (currentSeekTime >= 30 && !isVideoPlayedThirtySeconds.current) {
      handleOnPlayProgressThirtySeconds();
      isVideoPlayedThirtySeconds.current = true;
    }

    if (currentSeekTime > timeElapsedRef.current + 10) {
      handleOnPlayProgress();
      timeElapsedRef.current = currentSeekTime;
    }
  };

  const onSlideSeek = (time: number) => {
    if (videoRef.current) {
      videoRef.current.seek(time);
      currentTime.value = time;

      // updateRemainingTime();
    }
  };

  // const updateRemainingTime = () => {
  //   const remaining = max.value - currentTime.value;
  //   setRemainingTime(remaining);
  // };

  const enqueueEvent = (
    eventName: KissanEventType,
    additionalParams: { key: string; value: any }[] = [],
    customScreenDetails?: { screen?: string; screenTimeInSecs?: number }
  ) => {
    const commonDetails = [
      addEventParam('videoId', item?.actionData?.content.id),
      addEventParam(
        'deeplinkingUrl',
        `ninjakisan://longVideo/${item?.actionData?.content.id}?type=STREAM`
      ),
      addEventParam('recommendationId', item?.actionData?.content?.recommendationId),
      addEventParam('eventId', item?.actionData?.content?.eventId),
      addEventParam('videoPlaybackTime', currentInfoRef?.current?.currentTime),
      addEventParam('itemIndex', item?.actionData?.content?.itemIndex),
       addEventParam('referenceKey4', 'rankingId'),
        addEventParam('referenceValue4', item?.actionData?.content?.rankingId),
    ];
    const additionalDetails = [...commonDetails, ...additionalParams];
    const defaultScreenDetails = {
      screen: 'feed page',
    };
    const screenDetails = {
      ...defaultScreenDetails,
      ...customScreenDetails,
    };
    const event: INinjaEvent = {
      name: eventName,
      screenDetails,
      eventParams: additionalDetails,
    };
    processEvents([event]);
    if (sendToFirebasEvents.includes(eventName)) {
      handleMarketingEvents(eventName, screenDetails, additionalDetails);
    }
  };

  const onLoad = (e: any) => {
    max.value = e?.duration ?? 0;
  };

  const onLoadStart = (data: any) => {
    setIsLoading(true);
    startTimeRef.current = performance.now();
    enqueueEvent(KissanEventType.AUTO_PLAY_VIDEO_ON_READY_TIME);
  };

  const handleOnPlayEvent = () => {
    const bufferEndTime = performance.now();
    enqueueEvent(KissanEventType.AUTO_PLAY_VIDEO_PLAY);
    const calculatedBufferTime = msToTime(bufferEndTime - startTimeRef.current);
    if (calculatedBufferTime) {
      bufferTimeCapture(calculatedBufferTime);
    }
  };

  const bufferTimeCapture = (calculatedBufferTime) => {
    enqueueEvent(KissanEventType.AUTO_PLAY_VIDEO_BUFFER_TIME, [
      addEventParam('bufferTime', calculatedBufferTime),
    ]);
  };

  const handleOnPlayProgressOne = () => {
    enqueueEvent(KissanEventType.AUTO_VIDEO_PLAY_VIDEO_PROGRESS_ONE);
  };

  const handleOnPlayProgressThirtySeconds = () => {
    enqueueEvent(KissanEventType.AUTO_PLAY_VIDEO_PROGRESS_THIRTY_SECONDS);
  };

  const handleOnPlayProgress = () => {
    enqueueEvent(KissanEventType.AUTO_VIDEO_PLAY_VIDEO_PROGRESS);
  };

  const handleOnPlayProgressTwentySeconds = () => {
    enqueueEvent(KissanEventType.AUTO_PLAY_VIDEO_PROGRESS_TWENTY_SECONDS);
  };

  const onEnd = async () => {
    currentTime.value = duration ? ++duration : 0;
    const endTime = performance.now();
    const screenTiming = msToTime(endTime - startTimeRef.current);
    // max.value = 30;
    // updateRemainingTime()
    enqueueEvent(KissanEventType.AUTO_PLAY_VIDEO_PLAY_FINISH, [], {
      screenTimeInSecs: screenTiming,
    });
    hasAdEventTriggered.current = false;
  };

  const onPlaybackStateChanged = (
    e: Readonly<{ isPlaying: boolean; isSeeking: boolean }>
  ): void => {
    if (e.isPlaying) {
      setShowThumbnail(false);
      setTimeout(() => {
        setIsVideoReadyForPlay(true);
        if (!enableAutoPlayModeFired.current) {
          enableAutoPlayModeFired.current = true;
          onAutoPlayModeExpandCallback(true);
          console.log('Scroll to index called!!!');
        }
      }, 10);
    }
  };

  const handleBufferEnd = () => {
    if (!hasAdEventTriggered.current) {
      handleOnPlayEvent();
    }
  };

  const adEventMap = {
    LOADED: KissanEventType.ADS_LOADED,
    STARTED: KissanEventType.ADS_STARTED,
    // 'AD_PROGRESS': KissanEventType.ADS_PROGRESS,
    PAUSED: KissanEventType.ADS_PAUSED,
    FIRST_QUARTILE: KissanEventType.ADS_FIRST_QUARTILE,
    MIDPOINT: KissanEventType.ADS_MIDPOINT,
    THIRD_QUARTILE: KissanEventType.ADS_THIRD_QUARTILE,
    COMPLETED: KissanEventType.ADS_COMPLETED,
    CONTENT_PAUSE_REQUESTED: KissanEventType.VIDEO_CONTENT_PAUSE_REQUESTED,
    CONTENT_RESUME_REQUESTED: KissanEventType.VIDEO_CONTENT_RESUME_REQUESTED,
    SKIPPED: KissanEventType.ADS_SKIPPED,
    ALL_ADS_COMPLETED: KissanEventType.ALL_ADS_COMPLETED,
  };

  const onReceiveAdEvent = (e) => {
    const eventName = adEventMap[e?.event];
    const eventNameRaw = e?.event;

    const adStartEvents = ['ADS_STARTED', 'STARTED'];

    const hideGuestureEvents = [
      ...adStartEvents,
      'AD_PROGRESS',
      'FIRST_QUARTILE',
      'SKIPPABLE_STATE_CHANGED',
      'MIDPOINT',
      'THIRD_QUARTILE',
      'CONTENT_PAUSE_REQUESTED',
    ];

    const showGuestureEvents = [
      'ADS_SKIPPED',
      'SKIPPED',
      'COMPLETED',
      'ALL_ADS_COMPLETED',
      'ERROR',
      'CONTENT_RESUME_REQUESTED',
    ];

    videoAdPlayStartRef.current = true;

    if (adStartEvents.includes(eventNameRaw)) {
      setBannerAdLoad(false);
    }

    if (hideGuestureEvents.includes(eventNameRaw)) {
      setIsAdActive(true);
    }

    if (showGuestureEvents.includes(eventNameRaw)) {
      setIsAdActive(false);
    }

    if (eventName) {
      enqueueEvent(eventName);
    }
  };

  const onFeedItemPress = (event: any): void => {
    if (videoRef.current?.isMuted?.()) {
      videoRef.current?.toggleMute();
      // onVideoMuted?.(videoRef.current?.isMuted?.());
      event?.stopPropagation?.();
      event?.preventDefault();
      return;
    }

    // videoRef.current?.isMuted?.()

    if (isAdActive && isVideoFeedActive) {
      event?.stopPropagation?.();
      event?.preventDefault();
      return;
    }

    const additionalDetails = [
      addEventParam('itemId', item.actionData?.content?.id),
      addEventParam('postOwnerId', item.actionData?.content?.postOwnerId),
      addEventParam('mediaURL', item?.actionData?.mediaDetails[0]?.mediaUrl),
      addEventParam('videoId', item.actionData?.content?.id),
      addEventParam('recommendationId', item.actionData?.content?.recommendationId),
      addEventParam('itemIndex', item.actionData?.content?.itemIndex),
      addEventParam('eventId', item.actionData?.content?.eventId ?? ''),
      addEventParam('referenceKey4', 'rankingId'),
        addEventParam('referenceValue4', item?.actionData?.content?.rankingId),
    ];
    const eventToEnqueue: INinjaEvent = {
      name: pageName ? KissanEventType.PROFILE_OTHERS_ITEM_CLICK : KissanEventType.ITEM_CLICKED,
      screenDetails: { screen: 'feed video page' },
      eventParams: additionalDetails,
    };

    enqueue(eventToEnqueue);

    let videoPlayerTime = {
      userHistory: {
        currentTime: currentInfoRef?.current?.currentTime ?? 0,
      },
    };

    const adaptiveActionFormat: IAdaptiveActionCard = {
      ...item,
      actionData: {
        ...item.actionData,
        contentType: 'json',
        content: {
          ...item.actionData.content,
          ...videoPlayerTime,
        },
        mediaDetails: item.actionData.mediaDetails || [],
        props: item.actionData.props || [],
        eventNamePrefix: item.actionData.eventNamePrefix || '',
      },
    };

    // setLongVideoSelected?.(adaptiveActionFormat);
    // push(`/longVideo/${item.actionData?.content?.id}?adDelay=true`);
  };

  const onAdSizeChange = (adHeight: number, width: number) => {
    if (adHeight > 0) {
      console.log('Ad sixe chamge => ', adHeight);
      setBannerAdVisible(true);
    }
  };

  const handleAutoPlayAdEvent = (eventName) => {
    hasAdEventTriggered.current = true;
    const autoPlayAdeventToEnqueue = {
      name: eventName,
      screenDetails: { screen: 'feed video page' },
      eventParams: [addEventParam('videoId', item.actionData?.content?.id)],
    };
    enqueue(autoPlayAdeventToEnqueue);
  };

  useEffect(() => {
    if (bannerAdVisible) {
      videoRef?.current?.pause();
      handleAutoPlayAdEvent(KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_LOADED);
      handleMarketingEvents(
        KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_LOADED,
        { screen: 'feed video page' },
        [addEventParam('videoId', item.actionData?.content?.id)]
      );
      timeoutRef.current = setInterval(() => {
        bannerAdElapsedTimeRef.current = bannerAdElapsedTimeRef.current + 1;
        setAdElapsedTimer(Math.max(AD_SHOW_DURATION - bannerAdElapsedTimeRef.current, 0));

        if (bannerAdElapsedTimeRef.current >= AD_SHOW_DURATION) {
          isAdOpenedOrDismissed.current = true;
          videoRef.current?.resume();
          setBannerAdVisible(false);
          handleAutoPlayAdEvent(KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_DISMISS);
          clearTimeout(timeoutRef.current);
        }
      }, 1000);
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [bannerAdVisible]);

  const onFullscreenPlayerWillDismiss = () => {
    Orientation.lockToPortrait();
  };

  const onAdClosed = () => {
    isAdOpenedOrDismissed.current = true;
    console.log('🚀 ~ onAdClosed ~ isAdOpenedOrDismissed:', isAdOpenedOrDismissed);
    setBannerAdVisible(false);
    videoRef.current?.resume();
    handleAutoPlayAdEvent(KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_OPENED);
  };

  return (
    <Animated.View style={{ height: videoHeight, maxHeight: 250 }}>
      <YStack
        maxHeight={250}
        height={videoHeight}
        // onPress={bannerAdVisible ? undefined : onFeedItemPress}
      >
        {isVideoFeedActive && isFocused && (
          <>
            {/* {isAdCountStart && (
              <View position="absolute" bottom={10} left={10} zIndex={1} flexDirection="row">
                <Text
                  fontSize={14}
                  color={'#fff'}
                  backgroundColor={'#1112119c'}
                  padding={4}
                  borderRadius={6}
                >
                  {t('page.adStartingIn')}
                </Text>
                <View
                  width={30}
                  height={30}
                  backgroundColor={'#1112119c'}
                  borderRadius={6}
                  marginHorizontal={4}
                >
                  <LottieView
                    style={{ flex: 1 }}
                    source={countDownAnimationJSon}
                    autoPlay
                    loop={false}
                    onAnimationFinish={() => setAdCountStart(false)}
                  />
                </View>
              </View>
            )} */}

            <YStack
              testID="kisan_tId_FeedItem"
              onPress={bannerAdVisible ? undefined : onFeedItemPress}
              maxHeight={250}
              height={videoHeight}
            >
              {
                <Suspense
                  fallback={
                    <YStack flex={1} alignItems="center" justifyContent="center" width="100%">
                      <Spinner size="large" color="$blue10" />
                    </YStack>
                  }
                >
                  <Video
                    ref={videoRef}
                    source={isVideoFeedActive ? videoSource : undefined}
                    style={{
                      width: '100%',
                      height: videoHeight,
                      backgroundColor: '#0a0a0a',
                      display: isVideoReadyForPlay ? 'flex' : 'none',
                      //@ts-ignore
                      'data-nosnippet': true,
                    }}
                    controls={false}
                    paused={!isVideoFeedActive}
                    resizeMode="contain"
                    muted={true}
                    onPlaybackStateChanged={onPlaybackStateChanged}
                    onFullscreenPlayerWillDismiss={onFullscreenPlayerWillDismiss}
                    // poster={item?.actionData?.mediaDetails[0]?.preview_url}
                    onLoad={onLoad}
                    onLoadStart={onLoadStart}
                    onBuffer={handleBufferEnd}
                    onReceiveAdEvent={onReceiveAdEvent}
                    onProgress={onProgress}
                    adTagUrl={adTagurl}
                    onEnd={onEnd}
                    // adTagUrl={
                    //   'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll_skippable&sz=640x480&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator='
                    // }
                    onError={(e) => {
                      const autoPlayVideoPlayErrorEvent: INinjaEvent = {
                        name: KissanEventType.AUTO_PLAY_VIDEO_ERROR,
                        screenDetails: { screen: 'feed page' },
                        eventParams: [
                          addEventParam('errorMessage', e.toString()),
                          addEventParam('error', JSON.stringify(e)),
                          addEventParam('videoId', item?.actionData?.content.id),
                        ],
                      };
                      processEvents([autoPlayVideoPlayErrorEvent]);
                    }}
                  />
                </Suspense>
              }
            </YStack>

            {/* <NKPlayer
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#0a0a0a',
                display: isVideoReadyForPlay ? 'flex' : 'none',
              }}
              ref={playerRef}
              source={source}
              config={config}
              // onToggleFullScreen={onToggleFullScreen}
              onPlayProgress={onProgress}
              onPlaybackStateProgress={onPlaybackStateChanged}
              onLoad={onLoad}
              onEnd={onEnd}
              onLoadStart={onLoadStart}
              onReceiveAdEvent={onReceiveAdEvent}
              onError={(e) => {
                const autoPlayVideoPlayErrorEvent: INinjaEvent = {
                  name: KissanEventType.VIDEO_ERROR,
                  screenDetails: { screen: 'feed page' },
                  eventParams: [
                    addEventParam('errorMessage', e.toString()),
                     addEventParam('apiError', safeStringify(error)),
                  ],
                };
                enqueue(autoPlayVideoPlayErrorEvent);
              }}
            /> */}

            {isAutoPlayBannerAdEnabled &&
              isExpanded &&
              bannerAdLoad &&
              !isAdOpenedOrDismissed.current && (
                <XStack
                  marginTop={0}
                  display={bannerAdVisible ? 'flex' : 'none'}
                  maxHeight={250}
                  position="absolute"
                  top={0}
                  left={0}
                  right={0}
                  zIndex={1}
                  backgroundColor={'transparent'}
                >
                  <BannerAds
                    deviceWidth={deviceWidth ?? 0}
                    itemKey={`autoplay-banner-ad-${item?.actionData?.content?.id}`}
                    unitId={adUnits.feedpageVideoPlayerAd}
                    adSizeDefs={[BannerAdSize.MEDIUM_RECTANGLE]}
                    adsPreloadData={{}}
                    onAdSizeChange={onAdSizeChange}
                    onAdClosed={onAdClosed}
                    webAdSizeDefs={[[300, 250]]}
                    screenName={'feed page'}
                  />
                  <YStack
                    position="absolute"
                    top={0}
                    right={0}
                    padding={2}
                    backgroundColor="rgba(0, 0, 0, 0.8)"
                    zIndex={1}
                    height={28}
                    width={28}
                    alignItems="center"
                    alignSelf="center"
                  >
                    <SizableText size="$4" color="white" fontWeight={800}>
                      {adElapsedTimer}
                    </SizableText>
                  </YStack>
                </XStack>
              )}

            {/* {isVideoReadyForPlay && videoRef?.current && !isAdActive && !bannerAdVisible && (
              <>
                <View style={{ width: '100%' }}>
                  <FeedVideoSlider
                    progressProp={currentTime}
                    minProp={min}
                    maxProp={max}
                    remainingTime={remainingTime}
                    thumbScaleValue={thumbScaleValue}
                    onVideoSlidingComplete={onSlideSeek}
                    duration={item?.actionData?.content?.duration ?? 0}
                    isScrubbing={isScrubbing}
                    videoId={item?.actionData?.content?.id}
                  />
                </View>

                <Pressable
                  style={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    borderRadius: 20,
                    padding: 5,
                  }}
                  onPress={toggleMute}
                >
                  {feedVideoMuteEnable ? (
                    <VolumeX color={'#fff'} size={20} />
                  ) : (
                    <Volume2 color={'#fff'} size={20} />
                  )}
                </Pressable>
              </>
            )} */}
          </>
        )}

        {(!isVideoFeedActive || showThumbnail) && (
          <View testID="kisan_tId_FeedItem" onPress={onFeedItemPress}>
            <ImageBackground
              source={{ uri: item?.actionData?.mediaDetails?.[0]?.preview_url }}
              style={{ height: videoHeight, width: '100%' }}
              resizeMode={mediaQ.gtSm ? 'cover' : 'contain'}
              onError={(e) =>
                (thumbnail.current =
                  'https://tecxprts3qa.s3.amazonaws.com/1717487599615-image-clipping-effect.png')
              }
            >
              {!isVideoFeedActive && (
                <View
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <VideoPlayIconRegular size={50} color={theme['background']?.val} />
                </View>
              )}
              {isLoading && !isVideoReadyForPlay && (
                <View
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <ActivityIndicator size={50} color="#fff" />
                </View>
              )}
            </ImageBackground>
          </View>
        )}
      </YStack>
    </Animated.View>
  );
};

export default FeedVideoCard;
